export const BackgroundEffects = () => {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden">
      {/* Purple glow - top left */}
      <div 
        className="absolute -top-40 -left-40 w-[800px] h-[800px] rounded-full landing-glow"
        style={{ background: 'hsl(262, 83%, 53%)' }}
      />
      
      {/* Cyan glow - middle right */}
      <div 
        className="absolute top-1/3 -right-20 w-[600px] h-[600px] rounded-full landing-glow"
        style={{ background: 'hsl(187, 85%, 43%)' }}
      />
      
      {/* Fuchsia glow - bottom center */}
      <div 
        className="absolute -bottom-40 left-1/3 w-[500px] h-[500px] rounded-full landing-glow"
        style={{ background: 'hsl(292, 84%, 49%)' }}
      />

      {/* Decorative circles */}
      <div 
        className="absolute top-1/4 left-1/4 w-[400px] h-[400px] rounded-full border"
        style={{ borderColor: 'hsl(0, 0%, 100%, 0.03)' }}
      />
      <div 
        className="absolute bottom-1/4 right-1/4 w-[300px] h-[300px] rounded-full border"
        style={{ borderColor: 'hsl(0, 0%, 100%, 0.03)' }}
      />
    </div>
  );
};
